<template>
  <b-card :header-html="caption" v-if="items && items.length > 0">
    <b-table :dark="dark" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="captions" :current-page="currentPage" :per-page="perPage">
      <template #cell(status)="data">
        <div>
          <b-badge :variant="getPaymentStatusData(data.item).badge">{{getPaymentStatusData(data.item).text}}</b-badge>
        </div>
      </template>
      <template #cell(price)="data">
        <div>
          R${{data.item.price / 100}}
        </div>
      </template>
      <template #cell(paymentMethodType)="data">
        <div>
          {{getPaymentMethodTypeData(data.item).text}}
        </div>
      </template>
      <template #cell(actions)="data">
        <div>
          <b-button v-if="data.item.status == 0 && data.item.transactionCode" variant="success" @click="approvePayment(data.item._id)">Aprovar</b-button>
        </div>
      </template>
      <template #cell(date)="data">
        <div>
          {{data.item.date | moment("DD/MM/YYYY HH:mm")}}
        </div>
      </template>
    </b-table>
    <!-- <nav>
      <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Próxima" hide-goto-end-buttons/>
    </nav> -->
  </b-card>
</template>

<script>

import service from '../service'

export default {
  name: 'payment-history',
  inheritAttrs: false,
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    perPage: {
      type: Number,
      default: 5
    },
    dark: {
      type: Boolean,
      default: false
    },
    userId: undefined,
    admin: false,
    adminType: undefined
  },
  data: () => {
    return {
      currentPage: 1,
      paymentHistory: []
    }
  },
  computed: {
    items: function() {

      let items = [];

      if (this.paymentHistory && this.paymentHistory.length) {
        for (let key in this.paymentHistory) {
          let payment = this.paymentHistory[key];


          if (this.adminType == 1 && payment.type == "FREEPASS") {
            continue;
          }

          
          if (payment.transactionCode || payment.status !== 0) {
            items.push(payment);
          }
        }
      }

      return items;
    },
    fields: function() {
      let baseFields =
      [
        {
          label: 'Valor',
          key: "price"
        },
        {
          label: 'Data',
          key: "date"
        },
        {
          label: 'Status',
          key: "status"
        },
        {
          label: 'Método',
          key: "paymentMethodType"
        }
      ]

      if (this.admin) {
        baseFields.push({key: 'actions', label: 'Ações'})
      }

      return baseFields;
    },
    totalRows: function () { return this.getRowCount() },
    captions: function() { 

      let fields = this.fields;
      if (this.admin) {
        fields["actions"] =  {
          label: 'Ações'
        };
      }
      return fields 
    },
  },
  methods: {
    getPaymentStatusData (payment) {
      let paymentStatus = payment.status
      let statusData = {
        text: "Criado",
        badge: "default"
      };

      if (paymentStatus === 0 && payment.transactionCode)  {
        statusData.text =  "Aguardando pagamento";
        statusData.badge =  "warning";
      } else if (paymentStatus === 1) {
        statusData.text =  "Pago";
        statusData.badge =  "success";
      } else if (paymentStatus === 2) {
        statusData.text =  "Falho";
        statusData.badge =  "danger";
      }

      return statusData;
    },
    getPaymentMethodTypeData (payment) {
      let statusData = {
        text: "-"
      };

      if (payment.paymentMethodType) {
        if (payment.paymentMethodType == "1")  {
          statusData.text =  "Cartão de Crédito";
        } else if (payment.paymentMethodType == "2")  {
          statusData.text =  "Boleto";
        } else if (payment.paymentMethodType == "3")  {
          statusData.text =  "Débito online";
        } else if (payment.paymentMethodType == "4")  {
          statusData.text =  "Saldo PagSeguro";
        } else if (payment.paymentMethodType == "5")  {
          statusData.text =  "Oi Paggo";
        } else if (payment.paymentMethodType == "7")  {
          statusData.text =  "Depósito em conta";
        }
      }
      

      return statusData;
    },
    getRowCount: function () {
      return this.items.length
    },
    getPaymentHistory: function () {
      service.getPaymentHistory(this.userId).then(paymentHistory => {
        this.paymentHistory = paymentHistory;
      });
    },
    approvePayment: function(paymentId) {
      service.approvePayment(paymentId).then(paymentHistory => {
        this.getPaymentHistory();
      });
    }
  },
  created() {
    this.getPaymentHistory();
  }
}
</script>


